module.exports = __webpack_public_path__ + "img/stars.33e690e0.png";